import { render, staticRenderFns } from "./sendMessageTree.vue?vue&type=template&id=7ed67c5e&"
import script from "./sendMessageTree.vue?vue&type=script&lang=js&"
export * from "./sendMessageTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/other/sendMessageTree.vue"
export default component.exports